<template>
  <div
    v-if="guarantType === '0'"
    class="guarantList"
  >
    <h4>{{$t('records.guarant.list.title')}}</h4>
    <p>{{$t('records.guarant.list.subtitle')}}</p>
    <el-radio-group
      v-model="form.choice"
      class="guarantList__radioGroup"
      @change="onRadioChange()"
    >
      <el-radio label="1">
        {{$t('records.guarant.list.radio_yes')}}
        <guarantor-select
          v-model="form.guarant_id"
          class="guarantList__select"
          :placeholder="$t('records.guarant.list.select')"
          :disabled="form.choice === '0'"
          :change="onSelectChange"
        ></guarantor-select>
      </el-radio>
      <el-radio label="0">
        {{$t('records.guarant.list.radio_no')}}
      </el-radio>
    </el-radio-group>
  </div>
</template>

<script>
import GuarantorSelect from "@/components/ui/GuarantorSelect"

export default {
  name: 'GuarantList',
  components: { GuarantorSelect },
  data: () => ({
    form: {
      choice: '0',
      guarant_id: null
    }
  }),
  computed: {
    guarantType() {
      return this.$store.getters['recordsPeople/guarantType']
    }
  },
  methods: {
    onSelectChange() {
      this.$store.dispatch('recordsPeople/setGuarantId', this.form.guarant_id)
    },
    onRadioChange() {
      if (this.form.choice === '0') {
        this.form.guarant_id = null
        this.$store.dispatch('recordsPeople/setGuarantId', null)
      }
    }
  }
}
</script>

<style scoped lang="scss">
$c: '.guarantList';

#{$c} {
  background-color: white;
  padding: 24px;
  margin-bottom: 24px;

  & p {
    margin-bottom: 30px;
    margin-top: 0;
  }
  &__radioGroup {
    display: grid;
  }
  &__radioGroup .el-radio:first-child {
    margin-bottom: 20px;
  }
  &__select {
    margin-left: 40px;

    @include respond-below(xs) {
      display: flex;
      margin-top: 10px;
    }
  }
}
</style>